import React from "react";
import { Button } from "reactstrap";

function ButtonLoader(props) {
	const { className, btnTitle, onClick, showBtnLoading, disabled } = props;
	return (
		<Button className={className} onClick={onClick} disabled={disabled}>
			{showBtnLoading ? (
				<>
					<span
						class="spinner-border spinner-border-sm"
						role="status"
						aria-hidden="true"
					></span>
					<span className="pl-2">{btnTitle}</span>
				</>
			) : (
				<span>{btnTitle}</span>
			)}
		</Button>
	);
}

export default ButtonLoader;
